export const parseJson = async (response) => {
    const text = await response.text();
    try {
        const json = JSON.parse(text);
        return json;
    } catch (err) {
        // handle HTML in responses
        return text;
        // throw new Error(`Did not receive JSON, instead received: ${text}`);
    }
};

export const contructRequestObject = (form) => {
    const config = {};

    config.method = form.dataset.method || form.method;

    if (['POST', 'PUT', 'PATCH'].includes(config.method.toUpperCase())) {
        config.body = ['application/x-www-form-urlencoded'].includes(form.enctype)
            ? new URLSearchParams(new FormData(form))
            : new FormData(form);
    }

    // config.headers = {
    //     'Content-Type': form.enctype,
    // };

    // config.headers = {
    //     // 'Content-Type': 'application/json',
    //     'X-Requested-With': 'XMLHttpRequest',
    // };

    // if (form.dataset.headers) {
    //     config.headers = JSON.parse(form.dataset.headers);
    // }

    return config;
};
